import React from 'react';
import { Tag } from 'antd';
import {
  ExclamationCircleOutlined,
  WarningOutlined,
  InfoCircleOutlined,
  CheckCircleOutlined,
} from '@ant-design/icons';

const VaccinationStatusBadge = ({
  hasExpired = false,
  hasExpiringSoon = false,
  hasNoRecords = false,
  expiredCount = 0,
  expiringSoonCount = 0,
  size = 'medium',
  showLabel = true,
  onClick = null,
}) => {
  // Priority: Expired > Expiring Soon > No Records > OK
  let color, icon, label;

  if (hasExpired) {
    color = 'error';
    icon = <ExclamationCircleOutlined />;
    label = showLabel
      ? expiredCount > 0
        ? `${expiredCount} Expired`
        : 'Expired'
      : '';
  } else if (hasExpiringSoon) {
    color = 'warning';
    icon = <WarningOutlined />;
    label = showLabel
      ? expiringSoonCount > 0
        ? `${expiringSoonCount} Expiring Soon`
        : 'Expiring Soon'
      : '';
  } else if (hasNoRecords) {
    color = 'default';
    icon = <InfoCircleOutlined />;
    label = showLabel ? 'No Records' : '';
  } else {
    // All vaccinations are current - show OK status
    color = 'success';
    icon = <CheckCircleOutlined />;
    label = showLabel ? 'OK' : '';
  }

  // Map size to Ant Design tag sizes
  const tagSize =
    size === 'small' ? 'small' : size === 'large' ? 'large' : undefined;

  return (
    <Tag
      color={color}
      icon={icon}
      className={`${size === 'large' ? 'text-base px-3 py-1' : ''} ${onClick ? 'cursor-pointer hover:opacity-80' : ''}`}
      onClick={onClick}
    >
      {label}
    </Tag>
  );
};

export default VaccinationStatusBadge;
